/**
 * Hook for determining if a block is in the users viewport
 */

import { useEffect, useState, useRef } from 'react'
import { useLocation } from '@remix-run/react'
import throttle from 'lodash.throttle'

/**
 * Check if an element is in viewport
 */
const useVisibility = () => {
  const { pathname } = useLocation()
  const [isVisible, setIsVisible] = useState(false)
  const blockRef = useRef<HTMLDivElement>(null)

  // Check if current element is inside viewport
  const checkInView = () => {
    if (blockRef?.current) {
      const top = blockRef.current.getBoundingClientRect().top

      if (top >= 0 && top <= window.innerHeight * 0.8) {
        setIsVisible(true)
      }
    }
  }

  // Visibility check (with max run throttle)
  const onScroll = throttle(() => {
    checkInView()
  }, 100)

  // On scroll
  useEffect(() => {
    document.addEventListener('scroll', onScroll, true)
    return () => {
      document.removeEventListener('scroll', onScroll, true)
    }
  }, [])

  // On load
  useEffect(() => {
    checkInView()
  }, [pathname])

  return {
    blockRef,
    isVisible,
  }
}

export default useVisibility
